import { render, staticRenderFns } from "./LogisticsPrognoseLayer.vue?vue&type=template&id=821f688e&"
import script from "./LogisticsPrognoseLayer.vue?vue&type=script&lang=js&"
export * from "./LogisticsPrognoseLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports